export const actionRequestOptions = [
  'Cancel Case',
  'Change Case Status',
  'Other',
];

export const statusOptions = ['Up', 'Down', 'Faulty'];
